import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { MarkerPropsType } from './types'
import useHover from '@react-hook/hover'

// Components
import Icon from '../Icon'

// Styles
import './styles.scss'

// Icons Default
import IconStart from './images/iconStart'
import IconFinish from './images/iconFinish'
import IconHere from './images/iconHere'
import IconPopArrow from './images/iconPopArrow'
import IconGoLesson from './images/iconGoLesson'

const offsetIcons = {
  start: {
    top: 13.5,
    left: 15,
  },
  finish: {
    top: 13.5,
    left: 15,
  },
  circle: {
    top: 26.5,
    left: 26.5,
  },
  oval: {
    top: 31,
    left: 22.5,
  },
  rectangle: {
    top: 29,
    left: 20,
  },
  rounded_rectangle: {
    top: 26.5,
    left: 19.5,
  },
  rhombus: {
    top: 27,
    left: 27,
  },
  clover: {
    top: 26,
    left: 26,
  },
  hexagon: {
    top: 28.5,
    left: 28,
  },
  concave_cylinder: {
    top: 28.5,
    left: 21,
  },
}

export default ({
  type,
  color,
  x,
  y,
  moduleId,
  lessonId,
  moduleTitle,
  lessonTitle,
  timeStart,
  timeEnded,
  onJoinLesson,
  courseId,
  isAvailable,
  isBlocked,
  isJoined,
  isFinished,
  isHere,
  indexNumber,
}: MarkerPropsType) => {
  const [offsetPopOver, setOffsetPopOver] = useState<number>(0)

  const history = useHistory()

  const markerRef = useRef<HTMLDivElement | null>(null)
  const popUpRef = useRef<HTMLDivElement | null>(null)

  const isHovering = useHover(markerRef, { enterDelay: 0, leaveDelay: 0 })

  useEffect(() => {
    if (markerRef.current) {
      setOffsetPopOver(markerRef.current.offsetLeft)
    }
  }, [markerRef])

  const widthWindow = document.body.clientWidth
  const popOverLeft = widthWindow - (offsetPopOver + 700) < 0
  const widthPopUp = popUpRef.current?.offsetWidth || 0

  const getStatus = () => {
    if (!isAvailable) return 'time'
    if (isFinished) return 'complete'
    if (isBlocked) return 'blocked'
    if (isJoined) return 'joined'
    return 'default'
  }

  const flagTypes = ['start', 'finish']
  const blockedStatuses = ['time', 'blocked']
  const showIndexStatuses = ['joined', 'default']

  const disabled = blockedStatuses.includes(getStatus())

  const iconFlags = {
    start: <IconStart />,
    finish: <IconFinish />,
  }

  return (
    <div
      ref={markerRef}
      className={'marker'}
      style={{
        position: 'absolute',
        top: y,
        left: x,
        marginTop: -offsetIcons[type]?.top,
        marginLeft: -offsetIcons[type]?.left,
      }}
    >
      {isHere ? (
        <div className={'marker__here'}>
          <IconHere />
        </div>
      ) : null}
      {showIndexStatuses.includes(getStatus()) ? (
        <div className={'marker__content'}>
          <span className={'marker__content-index'}>{indexNumber}</span>
        </div>
      ) : null}
      {(flagTypes.includes(type) && type === 'start') || type === 'finish' ? (
        <>
          {iconFlags[type]}
          <br />
          <div
            className={'marker__title'}
            style={{ marginLeft: -offsetIcons[type]?.left }}
          >
            {type === 'start' ? 'Старт' : 'Финиш'}
          </div>
        </>
      ) : (
        <Icon
          type={type}
          status={getStatus()}
          isFill={isHovering}
          color={color || '#A3A3A3'}
          props={{
            width: offsetIcons[type]?.left * 2,
            height: offsetIcons[type]?.top * 2,
          }}
        />
      )}
      {!flagTypes.includes(type) ? (
        <div
          ref={popUpRef}
          className={popOverLeft ? 'marker__popover left' : 'marker__popover'}
          style={{
            top: '50%',
            transform: 'translateY(-50%)',
            left: popOverLeft
              ? -widthPopUp - 13
              : offsetIcons[type]?.left * 2 + 13,
          }}
        >
          <div
            className={
              popOverLeft
                ? 'marker__popover-arrow left'
                : 'marker__popover-arrow'
            }
          >
            <IconPopArrow />
          </div>
          <div className={'marker__popover-outer'}>
            <div className={'marker__popover-header'}>
              <span
                className={'circle'}
                style={{ background: color || '#A3A3A3' }}
              />
              <span className={'title'}>{moduleTitle}</span>
            </div>
            <div className={'marker__popover-info'}>
              <span className={'name'}>Урок:</span>
              <span className={'title'}>{lessonTitle}</span>
            </div>
            {getStatus() === 'time' ? (
              <div className={'marker__popover-info'}>
                <span className={'name'}>До начала:</span>
                <span className={'title'}>{timeStart || '—'}</span>
              </div>
            ) : (
              <div className={'marker__popover-info'}>
                <span className={'name'}>Время:</span>
                <span className={'title'}>{timeEnded || '—'}</span>
              </div>
            )}
          </div>
          <button
            onClick={() =>
              isJoined
                ? history.push(
                    `/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`
                  )
                : onJoinLesson(moduleId, lessonId)
            }
            disabled={disabled}
            className={'marker__popover-button'}
          >
            <IconGoLesson color={disabled ? '#C4C4C4' : '#F4BA27'} />
            <span>
              ПЕРЕЙТИ
              <br />К УРОКУ
            </span>
          </button>
        </div>
      ) : null}
    </div>
  )
}
